import React, { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { AppCard } from '@/layout/AppComponents';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import ReactDOMServer from 'react-dom/server';
import InformationTab from './InformationTab';
import CorrectiveActionsTab from './CorrectiveActionsTab';
import Translator from '../../../../../components/helpers/Translator';
import DelegatedResponsibleTab from './DelegatedResponsibleTab';
import ReviewTab from './ReviewTab';

export default function ExpandedContainer(props) {
  const { taskID, active } = props;
  const { moduleBridgeHex } = useParams();
  const level1 = useSelector((state) => state.currentPage?.levels?.level1);
  const modulePermissions = useSelector(
    (s) => s.module[moduleBridgeHex].permissions?.correctiveActions
  );
  const userBridge = useSelector(
    (s) => s?.module?.[moduleBridgeHex]?.userBridge
  );
  const moduleData = useSelector((s) => s.module[moduleBridgeHex].moduleData);
  const [activeTab, setActiveTab] = useState(active || 'info');

  return (
    <AppCard bodyClassName="p-0 mt-2">
      <Tabs defaultActiveKey={activeTab} onSelect={(v) => setActiveTab(v)}>
        <Tab
          eventKey="info"
          title={ReactDOMServer.renderToString(
            <Translator file="user" name="user.info" />
          )}
          className="p-3 border border-top-0 bg-white"
        >
          {activeTab === 'info' && <InformationTab taskID={taskID} />}
        </Tab>
        {moduleData?.taskUpdateTypesCount > 0 && (
          <Tab
            eventKey="correctiveActions"
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-correctiveActions"
                name="module.ca.gcl-actions"
              />
            )}
            className="pt-3 border border-top-0 bg-white"
          >
            {activeTab === 'correctiveActions' && (
              <CorrectiveActionsTab taskID={taskID} />
            )}
          </Tab>
        )}
        {(userBridge?.permissions?.level === 0 ||
          userBridge?.permissions?.delegate === true) && (
          <Tab
            eventKey="responsibles"
            title={ReactDOMServer.renderToString(
              <Translator
                file="module-correctiveActions"
                name="responsibles.delegation"
              />
            )}
            className="p-3 border border-top-0 bg-white"
          >
            {activeTab === 'responsibles' && (
              <DelegatedResponsibleTab taskID={taskID} />
            )}
          </Tab>
        )}
        {modulePermissions?.reviews && (
          <Tab
            eventKey="review"
            title={`${ReactDOMServer.renderToString(
              <Translator
                file="module-correctiveActions"
                name="module.ca.assessments"
              />
            )} (${level1?.[taskID]?.reviewCount ?? 0})`}
            className="p-3 border border-top-0 bg-white"
          >
            {activeTab === 'review' && <ReviewTab taskID={taskID} />}
          </Tab>
        )}
      </Tabs>
    </AppCard>
  );
}
